import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQrLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 34 30",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M33.3325 14.4993L25.9317 13.1194L25.0848 14.5972L23.0006 18.2342L17.5888 27.6777C17.3518 28.0911 16.7269 27.921 16.7269 27.4431V19.5066V18.645C16.7269 18.1977 16.4139 17.813 15.9801 17.7271L7.54857 16.0578L0.000976562 14.6671C0.0124392 15.0622 0.105037 15.4554 0.281362 15.8194L6.51059 26.7137C7.3797 28.2337 8.98432 29.1688 10.7196 29.1665L22.6656 29.1505C24.4 29.1482 26.0015 28.2098 26.867 26.6887L32.9633 15.9743C33.2233 15.5187 33.3454 15.0076 33.3325 14.4993Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.39792 14.5674L10.4854 10.9165L15.865 1.50775C16.1017 1.09384 16.7271 1.26374 16.7271 1.74197V10.5354C16.7271 10.9832 17.0408 11.3683 17.4753 11.4536L25.932 13.1141L33.3327 14.494C33.3233 14.1206 33.2402 13.7492 33.0835 13.4019C33.0467 13.3202 33.0072 13.2394 32.9622 13.1607L26.8581 2.45752C25.9908 0.936843 24.3877 0 22.6527 0H10.6659C8.92821 0 7.32297 0.939788 6.45673 2.4643L0.370016 13.1763C0.356001 13.2009 0.343841 13.2262 0.330624 13.251C0.0969467 13.6907 -0.012875 14.1774 0.00119908 14.6618L7.54879 16.0525L8.39792 14.5674Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1196_6997",
			x1: 32.6364,
			y1: 21.0565,
			x2: .600297,
			y2: 21.351,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3585A3" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00DEAE"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_1196_6997",
			x1: 1.6144,
			y1: 8.22391,
			x2: 30.0747,
			y2: 7.4877,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3585A3" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00DEAE"
			})]
		})] })
	]
});
export default SvgQrLogo;
